import { configure } from 'mobx';
import { createRoot } from 'react-dom/client';
import { polyfillAsync } from '../models/UiUtils';
import { AdminApp } from './containers/AdminApp';
import './styles/admin.less';

document.addEventListener('DOMContentLoaded', async () => {
	await polyfillAsync();
	if (!import.meta.env.PROD && import.meta.env.VITE_MOCKS === 'true') {
		const { worker } = await import('../mocks');
		await worker.start();
	}
	configure({ enforceActions: 'never' });
	const root = createRoot(document.getElementById('react-root'));
	root.render(<AdminApp />);
});
